import { Component } from '@angular/core';

@Component({
  selector: 'app-contatti',
  imports: [],
  templateUrl: './contatti.component.html',
  styleUrl: './contatti.component.scss'
})
export class ContattiComponent {

}
